import React from "react";

// Two static layers (sheen + edge glow). The glow's hue is cycled on the GPU
// via `filter: hue-rotate` rather than animating box-shadow — see foil.css.
//
// The overlay spans the card's full border-box (`-inset-px` over the container's
// 1px border) so its corners line up with the card image's clipped edge. It
// fills the parent rather than taking a `sizing` prop — the parent already
// constrains it, and sizing the overlay to the border-box was what threw the
// corner radius off.
export const CardFoilOverlay = () => {
  return (
    <div className="foil-overlay pointer-events-none absolute -inset-px">
      <div className="foil-sheen" />
      <div className="foil-glow" />
    </div>
  );
};
